import {
  AgentsExpertReviewIcon,
  AgentsGoChatIcon,
  AgentsHumanizerIcon,
  AgentsParaphraserIcon,
  AgentsProofreaderIcon,
  AgentsReaderReactionsIcon,
  CalendarIcon,
  GmailIcon,
  InterfacePlusIcon,
  JiraIcon,
  OutlookIcon,
} from './icons'

export const GOAgent = { icon: AgentsGoChatIcon, name: 'Go' }
export const ProofreaderAgent = { icon: AgentsProofreaderIcon, name: 'Proofreader' }
export const ExpertReviewAgent = { icon: AgentsExpertReviewIcon, name: 'Expert Review' }
export const ReaderReactionsAgent = { icon: AgentsReaderReactionsIcon, name: 'Reader Reactions' }

export type Agent = {
  icon: React.ComponentType
  name: string
  hideName?: boolean
}

export const fullAgents: Agent[] = [
  GOAgent,
  ProofreaderAgent,
  { icon: AgentsParaphraserIcon, name: 'Paraphraser' },
  { icon: AgentsHumanizerIcon, name: 'Humanizer' },
  ExpertReviewAgent,
  ReaderReactionsAgent,
  { icon: InterfacePlusIcon, name: 'Add agent' },
]

export const GmailAgent = { icon: GmailIcon, name: 'Mail' }
export const CalendarAgent = { icon: CalendarIcon, name: 'Calendar' }

export const cards = [
  {
    title: 'Outlook Mail',
    icon: OutlookIcon,
    description: 'Pull info from emails into your work.',
    added: false,
  },
  {
    title: 'Jira',
    icon: JiraIcon,
    description: 'Manage projects with minimal disruption.',
    added: false,
  },
  {
    title: GmailAgent.name,
    icon: GmailAgent.icon,
    description: 'Quick access to emails, anywhere.',
    added: false,
  },
  {
    title: CalendarAgent.name,
    icon: CalendarAgent.icon,
    description: 'Manage your calendar while staying in flow.',
    added: false,
  },
]

export type ReplaceAgent = {
  // agent
  agent: (typeof fullAgents)[number]
  // which index to replace
  index: number
}
